import Component from '../core/Component'
import support from '../utils/BrowserSupport'
import throttle from 'lodash/throttle'
import { triggerEvent } from '../utils/dom'

export const STATUS = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible'
}

export default class FilterLayer extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            cancel: null,
            submit: null,
            arrow: null
        }

        this.handleOuterClick = ::this.handleOuterClick
        this.handleKeydown = ::this.handleKeydown
        this.handleResize = throttle(::this.handleResize, 100)

        this.timer = 0
        this.origin = null
    }

    prepare() {
        this.element.addEventListener(support.transitionEnd, () => {
            if (!this.is(STATUS.ACTIVE)) {
                this.element.classList.remove(STATUS.VISIBLE)
            }
        })
        this.element.addEventListener('click', ::this.handleClick)
        this.ref.cancel.addEventListener('click', ::this.handleCancelClick)
        this.ref.submit.addEventListener('click', ::this.handleSubmitClick)

        window.addEventListener('resize', this.handleResize)
    }

    destroy() {
        this.close()
        window.removeEventListener('resize', this.handleResize)
    }

    open(origin) {
        if (Date.now() - this.timer < 200) {
            return
        }
        this.timer = Date.now()
        this.origin = origin

        this.element.classList.add(STATUS.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATUS.ACTIVE)

        this.position()

        document.body.addEventListener('click', this.handleOuterClick)
        document.body.addEventListener('keydown', this.handleKeydown)
    }

    close() {
        if (Date.now() - this.timer < 200) {
            return
        }
        this.timer = Date.now()

        this.element.classList.remove(STATUS.ACTIVE)
        document.body.removeEventListener('click', this.handleOuterClick)
        document.body.removeEventListener('keydown', this.handleKeydown)

        if (this.onClose) {
            this.onClose()
        }
    }

    toggle(origin) {
        if (this.is(STATUS.ACTIVE)) {
            this.close()
        } else {
            this.open(origin)
        }
    }

    position() {
        if (this.origin) {
            const containerBox = this.element.parentNode.getBoundingClientRect()
            const box = this.origin.getBoundingClientRect()
            const offset = box.height + box.top - containerBox.top
            this.element.style.top = `${offset}px`
        } else {
            this.element.removeAttribute('style')
        }

        this.setArrow(this.origin)
    }

    setArrow(origin) {
        if (!origin || !this.ref.arrow) {
            return
        }

        const originBox = origin.getBoundingClientRect()
        const box = this.element.getBoundingClientRect()
        const arrowBox = this.ref.arrow.getBoundingClientRect()

        this.ref.arrow.style.left = `${originBox.left + originBox.width/2 - box.left - arrowBox.width/2}px`
    }

    handleSubmitClick(event) {
        this.close()
    }

    handleCancelClick(event) {
        const input = this.element.querySelector('input')
        $(input).trigger('change')

        this.close()
    }

    handleClick(event) {
        event.stopPropagation()
    }

    handleOuterClick() {
        this.close()
    }

    handleKeydown(event) {
        if (event.keyCode === 27) {
            this.close()
        }
    }

    handleResize() {
        this.position()
    }

}